module.exports = __webpack_public_path__ + "img/juridocs.f0aad841.png";